export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyDIporHDDONHfiavfq9Sd5l2Upvuk9_JEk",
    authDomain: "kade-chat.firebaseapp.com",
    databaseURL: "https://kade-chat.firebaseio.com",
    projectId: "kade-chat",
    storageBucket: "",
    messagingSenderId: "42634767407"
  }
};



// WEBPACK FOOTER //
// /home/christopher/Work/Web/chat/src/environments/environment.ts